// @flow

// Types
export type PartialFlight = {
  flightCode: string,
  flightNumber: string,
  airlineCode: string,
}

/**
 * Parses the flight code in format `XX 1234` and returns an object
 * with available data. If not match found returns null.
 * @param  {string} query
 * @return {PartialFlight}
 */
const parseFlightQuery = (query: string): ?PartialFlight => {
  const flightMatch = query
    .trim()
    .toUpperCase()
    .match(/^([A-Z]{2,3}|[A-Z][0-9]|[0-9][A-Z])?\s*(\d+)?$/)
  if (!flightMatch || !query) {
    return null
  }
  return {
    flightCode: `${flightMatch[1] || ''}${flightMatch[2] || ''}`,
    flightNumber: flightMatch[2] || '',
    airlineCode: flightMatch[1] || '',
  }
}

export default parseFlightQuery
